import { PageHeader } from "antd";
import { Fragment, useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import BaseLayout from "../../../components/BaseLayout";
import ChartLayout from "../../../components/ChartLayout";
import useSpuInfo from "../../../stores/spuInfo";
import useSpuPoints from "../../../stores/spuPoints";
import Loading from "../components/Loading";
import EmptyChart from "../components/EmptyChart";
import DisplayUnitSelector from "../../SpuChart/components/DisplayUnitSelector";
import useDisplayUnits from "../../SpuChart/displayUnits/useDisplayUnits";
import PerformanceForm from "../Performance/PerformanceForm";
import LayeredCurveDebugChart from "./LayeredCurveDebugChart";

const PerformanceDebug = () => {
  const { id } = useParams() as { id: string };
  const { fetch: fetchInfo, spu } = useSpuInfo();
  const { fetch: fetchPoints, name, info, dataset, performance, loading } = useSpuPoints();
  const [searchParams, setSearchParams] = useSearchParams();
  const { displayUnits, updateDisplayUnit, setParamsWithDisplayUnits } = useDisplayUnits(
    searchParams,
    setSearchParams
  );

  useEffect(() => {
    fetchInfo(id);
    fetchPoints(id);
  }, [fetchInfo, fetchPoints, id]);

  if (loading) {
    return <Loading />;
  }

  if (!name || !dataset) {
    return <EmptyChart />;
  }

  const title = `${name || spu} Performance Debug`;

  return (
    <BaseLayout title={title}>
      <PageHeader title={title} style={{ padding: "16px 0" }} />
      <ChartLayout
        chart={
          <LayeredCurveDebugChart
            info={info}
            dataset={dataset}
            performance={performance.fieldsValue}
            displayUnits={displayUnits}
          />
        }
        form={
          <Fragment>
            <DisplayUnitSelector displayUnits={displayUnits} onChange={updateDisplayUnit} />
            <PerformanceForm
              displayUnits={displayUnits}
              setParamsWithDisplayUnits={setParamsWithDisplayUnits}
            />
          </Fragment>
        }
      />
    </BaseLayout>
  );
};

export default PerformanceDebug;
